import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import _ from "lodash";
import { ChevronDown, Search } from "lucide-react";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "28px", // Decrease this value to reduce the height
    height: "28px", // Ensure the height is consistently set
    backgroundColor: "transparent",
    borderRadius: "8px",
    borderColor: state.isFocused ? "#CAD1D7" : "#CAD1D7",
    boxShadow: state.isFocused ? null : null,
    fontSize: "13px", // Adjust font size here
    "&:hover": {
      borderColor: "#CAD1D7",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "13px", // Adjust font size here
    color: "#798797",
  }),

  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px",
    height: "28px",
    fontSize: "13px", // Adjust font size here
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    fontSize: "11px", // Adjust font size here
    width: "fit-content",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "28px",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "#798797" : "#798797",
    "&:hover": {
      color: "#798797",
    },
  }),
  menu: (provided) => ({
    ...provided,
    border: "none",
    fontSize: "13px",
    width: "100%", // Fixed width of the dropdown menu
    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.1)",
  }),
  menuList: (provided) => ({
    ...provided,
    border: "none",
    padding: "4px 4px",
    boxShadow: "none",
    width: "100%",
    maxHeight: "400px",
    overflowY: "auto", // Enable scrolling if the content exceeds the max height
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected
      ? "#F2F9FD" // Selected item background
      : isFocused
      ? "#EFFCFB" // Hover background
      : "#fff", // Default background
    color: isSelected ? "#174291" : "#798797", // Selected text color
    cursor: "pointer",
    borderRadius: "8px",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#2f9da9", // Change background color of selected values
    color: "white", // Change text color
    borderRadius: "24px", // Optional: rounded corners
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "white", // Ensure text color is visible
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "white",
    borderRadius: "0 24px 24px 0",
    ":hover": {
      backgroundColor: "#d32f2f", // Change background on hover (optional)
      color: "white",
    },
  }),
  groupHeading: (base) => ({
    ...base,
    fontWeight: 500,
    fontSize: "11px",
    color: "#c9c9c9",
    borderBottom: "1px solid #eaf6ff",
    background: "#fff",
    width: "100px",
  }),
};

const customDropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <ChevronDown size={16} style={{ color: "#aaa" }} />
      {/* <Search size={16} style={{ color: "#aaa" }} /> */}
      
      {/* Replace arrow with search icon */}
    </components.DropdownIndicator>
  );
};

const SelectComponentWithTabs = ({
  options,
  placeholder,
  handleValueChange,
  disabled=false,
  isMulti=false,
  isClearable=false,
  value=null
}) => {
  const [selectedOption, setSelectedOption] = useState(value);

  const handleChange = (option) => {
    if (!option) {
      setSelectedOption(null);
      handleValueChange(null);
      return;
    }

    if (typeof options === "object" && options.length < 1) {
      setSelectedOption(null);
      handleValueChange(null);
      return;
    }

    setSelectedOption(option);
    handleValueChange(option);
  };

  // const debounce = (func, delay) => {
  //   let timeoutId;
  //   return function (...args) {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //     timeoutId = setTimeout(() => {
  //       func.apply(this, args);
  //     }, delay);
  //   };
  // };

  // const handleInputChange = debounce((inputValue) => {
  //   // Call the API with the input value
  //   if (!_.isEmpty(inputValue) && !_.isEmpty(inputColumn)) {
  //     getSuggestionData(inputColumn, inputValue);
  //   }
  // }, 1000); 
  // Adjust the delay as needed (e.g., 1000 ms)

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={options}
      isDisabled={disabled}
      placeholder={placeholder}
      styles={customStyles}
      isClearable={isClearable}
      isMulti={isMulti}
      components={{ DropdownIndicator: customDropdownIndicator }} // Use custom dropdown indicator
    />
  );
};

export default SelectComponentWithTabs;
